import { string, object, z } from 'zod'
import { toTypedSchema } from '@vee-validate/zod'
import { inspectWebsiteDomain, WEBSITE_DOMAIN_MESSAGES } from '@dashboard/services/websiteDomain'

export const websiteDomainSchema = string().transform((value, context) => {
  const result = inspectWebsiteDomain(value)
  if (!result.ok) {
    context.addIssue({ code: z.ZodIssueCode.custom, message: WEBSITE_DOMAIN_MESSAGES[result.issue] })
    return z.NEVER
  }
  return result.website
})

export const emailSchema = string().nonempty('Email is required').email('Must be a valid email')

export const passwordSchema = string().nonempty('Password is required').min(8, 'Password must be at least 8 characters')
export const confirmPasswordSchema = string()
  .nonempty('New Password is required')
  .min(8, 'New Password must be at least 8 characters')

export const loginSchema = toTypedSchema(
  object({
    email: emailSchema,
    password: passwordSchema
  })
)
export const resetPasswordSchema = toTypedSchema(
  object({
    email: emailSchema,
    password: passwordSchema,
    confirmPassword: confirmPasswordSchema
  }).refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords should match',
    path: ['confirmPassword']
  })
)
export const addMemberSchema = toTypedSchema(
  object({
    email: emailSchema
  })
)

export const redirectUrlSchema = z.string().refine(
  (val) => {
    if (val.startsWith('//')) {
      return false
    }
    return /^(https?:\/\/|\/)[^\s]*$/.test(val)
  },
  { message: "Invalid URL: Must start with 'http://', 'https://', or '/' (protocol-relative URLs are not allowed)" }
)

export const integrationSchema = toTypedSchema(
  object({
    apiKey: string().nonempty('Api Key is required'),
    apiSecret: string().nonempty('Api Secret is required')
  })
)
